import React, { useState } from "react";
import './UploadButton.css';

function UploadButton({
    uploadMethod,
    buttonName = "Upload",
    disabled = false,
    style
}) {
    const [fileName, setFileName] = useState(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);
            uploadMethod(file);
        }
    };

    const buttonStyle = {
        minWidth: '80px',
        float: 'right',
        color: disabled ? 'rgba(32, 27, 35, 0.53)' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        alignContent: 'center',
        ...style
    };

    return (
        <div style={buttonStyle} className={`button-field`}>
            <input
                type="file"
                id={`file-upload`}
                onChange={handleFileChange}
                style={{ display: "none" }}
            />
            <label
                htmlFor={`file-upload`}
                style={{ padding: '5px', cursor: 'pointer' }}
            >
                {buttonName}
            </label>
        </div>
    );
}

export default UploadButton;
